import { render, staticRenderFns } from "./GiftExchange.vue?vue&type=template&id=088e8afc&scoped=true"
import script from "./GiftExchange.vue?vue&type=script&lang=js"
export * from "./GiftExchange.vue?vue&type=script&lang=js"
import style0 from "./GiftExchange.vue?vue&type=style&index=0&id=088e8afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088e8afc",
  null
  
)

export default component.exports